<template>
  <footer id="footer-section" class="modern-footer">
    <div class="footer-content">
      <div class="copyright-bar">
        <div class="copyright-text">
          © {{ new Date().getFullYear() }} Shanrise. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.modern-footer {
  width: 100%;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  padding: 2rem 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.copyright-bar {
  text-align: center;
  color: #64748b;
  font-size: 0.9rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-footer {
    padding: 1.5rem 0;
  }
}
</style>

<script>
export default {
  name: "ModernFooter",
};
</script>
